export const formatCurrency = (value: number, minimumFractionDigits = 2, maximumFractionDigits = 2): string => {
  const val = value ? value / 100 : 0;
  return `${val.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  })}`;
};
